import React from "react";
import "./office.css";

const Office = () => {
  return (
    <>
      <div className="officePage">
        <div className="officeHead">
          <h2>
            Our <span>Office</span>
          </h2>
        </div>
      </div>
    </>
  );
};

export default Office;
